import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import "./styles/Log.css"
import { data } from "react-router-dom";
import { FormatedDate } from "../util/FormatedDate";

//RepPrA
const Log = ({user, action, dateU}) =>{
    const navigate = useNavigate();

    const handleRedireccionarLog = (e) =>{
        e.preventDefault();
        navigate('/logs')
    }

    return(
        <div className="Log" onClick={handleRedireccionarLog}>
            <div className="LogName">
                {user}
            </div>
            <div className="LogAction">
                {action}
            </div>
            <div className="LogDate">
                {FormatedDate(dateU)}
            </div>
            
        </div>
    );
}

export default Log;